import { SETTOGGLEIMAGES } from "../constants/action_types.js"

export const aToggleArtworkDisplay = () => async (dispatch) =>
{
  try
  {
    dispatch({ type: SETTOGGLEIMAGES });
  }
  catch (err)
  {
    console.trace(err);
  }
}
